export interface LatLng {
    lat: number;
    lng: number;
}

export enum SafetyStatus {
    SAFE = 'SAFE',
    DANGER = 'DANGER',
    SOS = 'SOS',
    WARNING = 'WARNING',
    HOME = 'HOME',
    OFFLINE = 'OFFLINE'
}

export enum HazardType {
    EARTHQUAKE = 'EARTHQUAKE',
    FIRE = 'FIRE',
    TSUNAMI = 'TSUNAMI',
    FLOOD = 'FLOOD',
    TORNADO = 'TORNADO',
    BIOHAZARD = 'BIOHAZARD',
    SOS = 'SOS',
    TRAFFIC = 'TRAFFIC',
    CRASH = 'CRASH',
    POLICE = 'POLICE',
    CIVIL = 'CIVIL',
    WEATHER = 'WEATHER',
    NUCLEAR = 'NUCLEAR',
    ALERT = 'ALERT'
}

export interface Alert {
    id: string;
    type: HazardType;
    severity: 'critical' | 'high' | 'medium' | 'low';
    coordinates: LatLng;
    location: string;
    description?: string;
    timestamp?: string;
    time?: string;
    survivalTips?: string[];
    headline?: string;
}

export interface Contact {
    id: string;
    name: string;
    role?: string;
    status: SafetyStatus;
    battery?: number;
    locationName?: string;
    coordinates: LatLng;
    lastSeen: string;
    avatarUrl?: string;
    nid?: string;
    lastUpdated?: number;
    isTrackable?: boolean;
    lastMessage?: string;
    lastMessageTime?: number;
    lastEmoji?: string;
    unreadCount?: number;
}

export enum ViewState {
    DASHBOARD = 'DASHBOARD',
    INTEL_FEED = 'INTEL_FEED',
    COMMAND_CENTER = 'COMMAND_CENTER',
    INTEL_CORTEX = 'INTEL_CORTEX',
    CONTACTS = 'CONTACTS',
    PROFILE = 'PROFILE',
    MESSENGER = 'MESSENGER',
    PULSE = 'PULSE',
    INTEL = 'INTEL'
}

export interface WeatherData {
    temp: number;
    condition: string;
    humidity: number;
    windSpeed: number;
    locationName: string;
    isNight: boolean;
}

export interface NewsItem {
    id: string;
    headline: string;
    location: string;
    time: string;
    severity?: string;
    type?: string;
    summary?: string;
    source?: string;
}

export type Language = 'en' | 'fr' | 'ar';

export interface BeaconState {
    active: boolean;
    type: HazardType | null;
    startTime: number;
    lastBroadcast: string;
}

export interface IncomingRequest {
    senderId: string;
    senderName: string;
    timestamp: Date;
}

export interface Achievement {
    id: string;
    title: string;
    description: string;
    icon: string;
    unlocked: boolean;
    date?: string;
}
